import qs from 'qs'
import request from '@/utils/request'
import '@/utils/types.js'

/**
 * @returns {RequestLifeCycle}
 */
export function getRequestLifecycle() {
  return request({
    url: `/api/requests/lifecycle/`,
    method: 'get',
  })
}
/**
 * @param {{
 * state?: RequestStateMethods,
 * "me.author"?: boolean,
 * "me.assignee"?: boolean,
 * "store.id"?: number,
 * "route.code"?: number,
 * "created.start"?: string,
 * "created.end"?: string
 * limit?: number,
 * offset?: number
 * }} params
 * @returns {{requests: RequestShort}}
 */
export function getRequests(params) {
  return request({
    url: `/api/requests/`,
    method: 'get',
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}
/**
 * @param {RequestCreate} data
 * @returns {RequestFull}
 */
export function createRequest(data) {
  return request({
    url: `/api/requests/`,
    method: 'post',
    data,
  })
}
/**
 * @param {number} requestId
 * @returns {RequestFull}
 */
export function getRequest(requestId) {
  return request({
    url: `/api/requests/${requestId}/`,
    method: 'get',
  })
}
/**
 * @param {number} requestId
 * @param {{
 * gi: number, installation: Installation,
 * dismantling: Installation, comments?: string
 * }} data
 * @returns {RequestFull}
 */
export function updateRequest(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/`,
    method: 'patch',
    data,
  })
}
/**
 * @param {{requestId: number, method: RequestStateMethods}} params
 * @param {{comment?: string}} data
 * @returns {RequestFull}
 */
export function setRequestState({ requestId, method }, data) {
  return request({
    url: `/api/requests/${requestId}/state/${method}/`,
    method: 'post',
    data,
  })
}
/**
 * @param {number} requestId
 * @param {{role: UserRoles}} data
 * @returns {RequestFull}
 */
export function approveRequest(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/approval/approve/`,
    method: 'post',
    data,
  })
}
/**
 * @param {number} requestId
 * @param {{role: UserRoles}} data
 * @returns {RequestFull}
 */
export function revokeRequest(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/approval/revoke/`,
    method: 'post',
    data,
  })
}

/**
 * Поиск задач
 * @param {number} requestId
 * @returns {{tasks: RequestTaskShort[]}}
 */
export function getRequestTasks(requestId) {
  return request({
    url: `/api/requests/${requestId}/tasks/`,
    method: 'get',
  })
}

/**
 * Создать задачу
 * @param {number} requestId
 * @param {{assignee: number, text: string}} data
 * @returns {RequestTask}
 */
export function createRequestTasks(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/tasks/`,
    method: 'post',
    data,
  })
}

/**
 * Детальная информация по задаче
 * @param {{requestId: number, taskId: number}} params
 * @returns {RequestTask}
 */
export function getRequestTask({ requestId, taskId }) {
  return request({
    url: `/api/requests/${requestId}/tasks/${taskId}/`,
    method: 'get',
  })
}

/**
 * Завершить/отменить задачу
 * @param {{requestId: number, taskId: number, type: "cancel" | "complete"}} params
 * @param {{comment: string}} data
 * @returns {RequestTask}
 */
export function changeRequestTask(
  { requestId, taskId, type = 'complete' },
  data
) {
  return request({
    url: `/api/requests/${requestId}/tasks/${taskId}/${type}/`,
    method: 'post',
    data,
  })
}

/**
 * Добавить/удалить макет к/из заявки
 * @param {{requestId: number, type: "append" | "remove"}} params
 * @param {{layout: number}} data
 * @returns {LayoutShort | undefined}
 */
export function changeRequestLayout({ requestId, type }, data) {
  return request({
    url: `/api/requests/${requestId}/layouts/${type}/`,
    method: 'post',
    data,
  })
}

/**
 * Возвращает схемы согласования заявок
 * @returns {{states: {state: RequestStateMethods, roles: UserRole[]}}}
 */
export function getRequestsSchemas() {
  return request({
    url: `/api/approval/requests/`,
    method: 'get',
  })
}

export function getRequestGI(params) {
  return request({
    url: `/api/requests/request_gi/`,
    method: 'get',
    params,
  })
}

export function appendPreviewPhoto({ requestId, photoId }) {
  return request({
    url: `/api/requests/${requestId}/preview_photo/append/${photoId}/`,
    method: 'post',
  })
}

export function removePreviewPhoto({ requestId, photoId }) {
  return request({
    url: `/api/requests/${requestId}/preview_photo/remove/${photoId}/`,
    method: 'delete',
  })
}

export function createRequestPosm(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/posm/`,
    method: 'post',
    data,
  })
}

/**
 * Генерация отчета сквозной аналитики
 * @returns {Promise}
 */
export function generateCrossAnalytics(params) {
  return request({
    url: '/api/requests/cross-analytics/',
    method: 'post',
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}

export function addEntityToRequest(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/entity/`,
    method: 'post',
    data,
  })
}

export function removeEntityFromRequest(requestId, data) {
  return request({
    url: `/api/requests/${requestId}/entity/`,
    method: 'delete',
    data,
  })
}

export function getRequestsAssignmentHistory(params) {
  return request({
    url: `/api/requests/assignment-history/`,
    method: 'get',
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}
